import React from "react";
import Layout from "../components/Layout";
import SEO from "../components/SEO";
import { businessInfo, whyChoose } from "../constants";
import { CheckCircle2, ArrowRight, MessageCircle } from "lucide-react";
import { Link } from "react-router-dom";

export default function About() {
  return (
    <Layout>
      <SEO title="About Revive Solutions | Authorised Elica Service Provider in Pune" description="Revive Solutions is an authorised Elica service provider based in Wanowrie, Pune. We service Elica chimneys, hobs, cooktops, ovens, microwaves and dishwashers." canonical="/about" />
      <section className="bg-[#0b1220] text-white py-14">
        <div className="max-w-5xl mx-auto px-6">
          <div className="chip chip-dark mb-4">About us</div>
          <h1 className="font-display text-4xl md:text-5xl font-medium leading-tight mb-3">Authorised Elica Service Provider in Pune</h1>
          <p className="text-white/70 max-w-2xl">Revive Solutions is a dedicated Elica after-sales service business based out of {businessInfo.location}.</p>
        </div>
      </section>
      <section className="py-14 bg-white">
        <div className="max-w-5xl mx-auto px-6 grid lg:grid-cols-2 gap-12 items-start">
          <div>
            <h2 className="font-display text-2xl md:text-3xl font-medium mb-4">Who we are</h2>
            <p className="text-slate-600 leading-relaxed mb-4">Revive Solutions is an authorised Elica service provider. We focus exclusively on Elica kitchen appliances – chimneys, hobs, cooktops, built-in ovens, microwave ovens and dishwashers. We do not service ACs, refrigerators, washing machines or unrelated appliances, and this focus is what lets us do our job well.</p>
            <p className="text-slate-600 leading-relaxed mb-6">Our team provides doorstep diagnostic, repair, cleaning, installation and maintenance across select Pune PIN codes, using genuine Elica spare parts and clear starting prices.</p>
            <div className="space-y-3 mb-8">
              {["Authorised Elica service provider", "Genuine Elica spare parts", "Transparent starting prices", "Doorstep visits at your convenience"].map((p) => (
                <div key={p} className="flex items-start gap-2.5"><CheckCircle2 className="w-5 h-5 text-[#e30613] mt-0.5 flex-shrink-0" /><span className="text-[15px]">{p}</span></div>
              ))}
            </div>
            <Link to="/book-service" className="btn-primary">Book a Service <ArrowRight className="w-4 h-4" /></Link>
          </div>
          <div>
            <div className="rounded-lg overflow-hidden bg-neutral-100 aspect-[4/5]">
              <img src="https://images.unsplash.com/photo-1600489000022-c2086d79f9d4?crop=entropy&cs=srgb&fm=jpg&q=85" alt="Modern Elica kitchen" className="w-full h-full object-cover" />
            </div>
          </div>
        </div>
      </section>
      <section className="py-14 section-cream">
        <div className="max-w-5xl mx-auto px-6">
          <h2 className="font-display text-2xl md:text-3xl font-medium mb-8 text-center">What sets us apart</h2>
          <div className="grid md:grid-cols-3 gap-5">
            {whyChoose.slice(0, 6).map((w) => (
              <div key={w.title} className="bg-white p-6 border border-neutral-200 rounded-lg hover-card">
                <h3 className="font-semibold text-[15px] mb-2">{w.title}</h3>
                <p className="text-sm text-slate-500 leading-relaxed">{w.desc}</p>
              </div>
            ))}
          </div>
          <div className="text-center mt-10">
            <a href={businessInfo.whatsapp} target="_blank" rel="noreferrer" className="btn-ghost"><MessageCircle className="w-4 h-4" /> Chat with us on WhatsApp</a>
          </div>
        </div>
      </section>
    </Layout>
  );
}
